import React, { Component } from 'react';

import PromoterBindTable from '../tables/PromoterBindTable';
import BindModal from '../BindModal';

export default class PromoterShopBindModal extends Component {
    getInitialValues() {
        const { params: { id }} = this.props;

        return {
            shop: id,
            type: 'promoterShop'
        };
    }

    render() {
        return (
            <BindModal
                {...this.props}
                title='Привязать консультанта'
                initialValues={this.getInitialValues()}
                steps={[
                    { title: 'Выбор консультанта', table: PromoterBindTable, path: 'promoter' }
                ]}
            />
        );
    }
}
